import { useSearchParams } from "react-router";

import { ResetPasswordCard } from "@components/Cards";

import classes from "./ResetPassword.module.css";

const PASSWORD_TOKEN_TYPE = "multi_tenant_passwords";

export const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const tokenType = searchParams.get("stytch_token_type");
  const passwordToken =
    tokenType === PASSWORD_TOKEN_TYPE && token ? token : null;

  return (
    <div className={classes.container}>
      <ResetPasswordCard token={passwordToken} />
    </div>
  );
};
